import React, { useState, useMemo, useEffect } from "react";
import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { highlightPartialKeyword } from "../../../../components/HighlightKeyword";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

// pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.min.mjs`;

export default function PDFPreview({
  pdf,
  defaultPage = 1,
  query,
  onLoadSuccess,
  scale,
}) {
  const [numPages, setNumPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(defaultPage);
  const [isDocumentReady, setIsDocumentReady] = useState(false);
  const options = useMemo(
    () => ({
      cMapUrl: "/cmaps/",
      standardFontDataUrl: "/standard_fonts/",
    }),
    []
  );

  useEffect(() => {
    setCurrentPage(defaultPage); // Update currentPage when defaultPage prop changes
  }, [defaultPage]);
  // useEffect(() => {
  //   // Fetch the PDF file from the server
  //   fetch("http://localhost:8080/document/test/pdf/file", {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/pdf",
  //     },
  //   })
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       // Create a blob URL and set it as the file
  //       const url = URL.createObjectURL(blob);
  //       setFile(url);
  //     })
  //     .catch((error) => console.error("Error fetching PDF:", error));
  // }, []);

  const onDocumentLoadSuccess = ({ numPages: nextNumPages }) => {
    setNumPages(nextNumPages);
    setCurrentPage(Math.min(currentPage, nextNumPages));
    setIsDocumentReady(true);
    onLoadSuccess(nextNumPages);
  };

  return (
    <div className="Example">
      <div className="Example__container">
        <div className="Example__container__navigation">
          {/* <button onClick={fetchPdf}>Load PDF</button> */}
          {/* <button onClick={goToPreviousPage} disabled={currentPage <= 1}>
            Previous
          </button>
          <span>
            Page {currentPage} of {numPages}
          </span>
          <button onClick={goToNextPage} disabled={currentPage >= numPages}>
            Next
          </button> */}
        </div>
        <div className="Example__container__document">
          <Document
            file={pdf}
            onLoadSuccess={onDocumentLoadSuccess}
            options={options}
          >
            {numPages > 0 && isDocumentReady && (
              <Page
                pageNumber={currentPage}
                height={800}
                scale={scale}
                renderTextLayer={true}
                customTextRenderer={({ str }) =>
                  highlightPartialKeyword(str, query)
                }
              />
            )}
          </Document>
        </div>
      </div>
    </div>
  );
}
